import type { ComponentProps } from 'react'
import cn from '@components/utils/cn'

function Skeleton({ className, ...props }: ComponentProps<'div'>) {
  return <div className={cn('tw:animate-pulse tw:rounded-md tw:bg-gray-200', className)} {...props} />
}

export { Skeleton }
